import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import createStore from "./createStore";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserProvider } from "./features/utils/userContext";

const store = createStore();

ReactDOM.render(
  <React.StrictMode>
    <UserProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </UserProvider>
  </React.StrictMode>,
  document.getElementById("el-lead-capture-widget")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
